import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { registrarEvento } from './telemetry/eventos-de-funil';

@Injectable({ providedIn: 'root' })
export class OpenPanelService {
	private initialized = false;

	init(restaurantId: number, flowType: string): void {
		if (this.initialized || !restaurantId) return;
		this.initialized = true;

		const w = window as any;
		w.op = w.op || function (...args: any[]) { (w.op.q = w.op.q || []).push(args); };

		w.op('init', {
			apiUrl: environment.openPanel.apiUrl,
			clientId: environment.openPanel.clientId,
			trackScreenViews: true,
			trackOutgoingLinks: true,
			trackAttributes: true,
		});
		w.op('setGlobalProperties', { restaurant_id: String(restaurantId), flow_type: flowType });

		const script = document.createElement('script');
		script.src = 'assets/js/op1.js';
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);
	}

	track(name: string, properties: { [key: string]: any } = {}): void {
		// Espelho para as gravações de tela, e ele vem ANTES do guard de
		// propósito: é o que permite filtrar gravação por etapa no painel
		// ("me mostre quem revisou o pedido e não comprou").
		//
		// FORA do `if (!this.initialized)` porque os destinos têm gates
		// diferentes. Em green/blue/yellow o OpenPanel só inicializa para as
		// lojas 1 e 460 (ver restaurant.service); dentro do guard, o yellow
		// gravaria sem evento nenhum — justamente o ambiente onde isso vai ser
		// testado. `registrarEvento` tem gate próprio: sem gravador ligado, ele
		// guarda no histórico para quem assinar depois.
		registrarEvento(name, properties);

		const w = window as any;
		// op1.js troca w.op por um Proxy cujo alvo é uma função (garante typeof === 'function').
		// Se revendorizar o SDK, confirmar que esse invariante continua valendo.
		if (!this.initialized || typeof w.op !== 'function') return;
		w.op('track', name, properties);
	}

	/**
	 * Publica uma propriedade global no OpenPanel depois do `init`.
	 *
	 * Existe para a ponte INVERSA: com `replay_url` aqui, uma linha do funil no
	 * OpenPanel vira um clique para a gravação. Sem ela a integração é de mão
	 * única — dá para achar a sessão a partir do evento, mas não o contrário.
	 */
	setGlobalProperty(chave: string, valor: string): void {
		const w = window as any;
		if (!this.initialized || typeof w.op !== 'function' || !valor) return;
		w.op('setGlobalProperties', { [chave]: valor });
	}
}
